// extracted by mini-css-extract-plugin
export default {"host":"PageHeaderAside_host__HEBi0"};